<template>
  <div class="details">
    <div class="details-container">
      <p class="category">{{ categoryName }}</p>
      <ScText tag="h1" class="title" :field="fields.title"/>
      <ScText tag="div" class="desc" :field="fields.shortDescription"/>
      <ScText :editable="false" class="author" :field="fields.author"/>
      <date-formatter :timeStamp="fields.publishDate.value" :type="timeFormat"/>
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue'

export default {
  name: 'WhiteBoard',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScText: Text
  },
  computed: {
    categoryName () {
      //  todo: create is edit mode | data source exist mixin
      if (this.fields && this.fields.categories && this.fields.categories[0]) {
        return this.fields.categories[0].fields.title.value
      }

      return null
    },
    timeFormat () {
      return 'abrDate'
    }
  }
}
</script>

<style lang="scss" scoped>

.details {
  margin: 0 $d-xx-small;
  background: $color-white;
  position: relative;

  @include tablet {
    max-width: 64em;
    width: 80%;
    margin: auto;
  }
}

.details-container {
  padding: $space-060 $d-xx-small $space-070;
  text-align: center;
  margin: auto;

  @include tablet {
    padding: $space-080 $d-x-large;
    width: 80%;
  }

  .category {
    @include font('040');

    color: $color_gray_4;
    margin-top: 0;
    margin-bottom: $space-040;

    @include tablet {
      @include font('050');

      margin-bottom: $space-050;
    }
  }

  .title {
    @include font('100');

    font-weight: normal;
  }

  .desc {
    @include font('060');
    
    color: $color_gray_4;
    padding-bottom: $space-070;
    margin: $space-060 0 $space-070;
    border-bottom: $line-medium;
  }

  .author {
    @include font('040');
    
    color: $color_gray_4;
    display: block;
    margin-bottom: $space-040;
  }

  .date {
    color: $color_gray_4;
  }
}

</style>
